module.exports = __webpack_public_path__ + "static/media/heart_red.22b8dedf.svg";